/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { useMedia } from '@api/hooks';
import { InfoItem } from '@molecules';
import { getImage } from '@utils/media';

const Item = ({ module, errors }) => {
  const { media } = useMedia(getImage(module.content));
  const description = module?.content?.title;

  return (
    <InfoItem.WithError description={description} error={errors} size="large" image={media.src}>
      Timetable
    </InfoItem.WithError>
  );
};

export default Item;
